import { useCallback, useEffect, useMemo, useState } from "react";
import useWebSocketOps from "./useWebSocketOps";
import useSmartRef from "./useSmartRef";
import { useOperatorContext } from "../comps/login/OperatorContextProvider";
import { useWebSocketContext, WebSocketFlag } from "../providers/WebSocketContextProvider";

//@Deprecated. 
//    Replaced by: useTopicHandler, useQueueHandler and useWebSocketCaller as necessary.
//    Still used by non-refactored components such as Tasks, Tikia, etc..   Should be deleted after those components will be refactored as well.
// queues, topics objects each provides a map of channel and handler.
export default function useWebSocketComm(apiEndpoint, request, userQueueName, teamTopicName, autoSend = true, requestor) {
  const {operatorState, isOperatorReady, operator}                          = useOperatorContext();
  const {wsSubscribe, wsUnsubscribe, webSocketState, isWebSocketFlag}       = useWebSocketContext();
  const {wsSendMessage}                                                     = useWebSocketOps();
  const {get:getMySubsList}                             = useSmartRef({});
  const {get:isAutoMessageSent, set:setAutoMessageSent} = useSmartRef(false);
  const [msgData,setMsgData]                            = useState(null);
  const [topicData, setTopicData]                       = useState(null);
  const [topicPath, setTopicPath]                       = useState(null);
  const [isActorMounted, setActorMounted]               = useState(false);
  const qPath = useMemo(()=>  userQueueName ? `/user/queue/${userQueueName}` : null, [userQueueName]);
  
  // ---[  Subscribe If Absent  ]---
  //
  const subscribeIfAbsent = useCallback((channelName, handler) => {
    // ---[  Has Subs  ]---
    const isInMySubsList = (ch) => {
      return Boolean(getMySubsList()[ch]);
    }

    if (!isInMySubsList(channelName)) {
      const sId = wsSubscribe(channelName, handler, true);
      if (sId) {
        getMySubsList()[channelName] = sId;
        console.log('[useWebSocketComm subscribeIfAbsent] My Page List [channel: %s] [sId: %s]', channelName, sId);
      }
      else {
        console.error('[useWebSocketComm subscribeIfAbsent] No Result from wsSubscribe [sId: %s]', sId);
      }
    }
  }, [getMySubsList, wsSubscribe]);

  // ---[  Send Message  ]---
  //
  const sendMsg = useCallback((requestData = request) => {
    if (requestor) {
      requestData = requestor(operator);
    }
    console.debug('[useWebSocketComm sendMsg] [requestData: %s]', JSON.stringify(requestData));
    wsSendMessage(apiEndpoint, requestData);
  }, [apiEndpoint, operator, request, requestor, wsSendMessage]);

  // 
  // ---[  onMsgData  ]---
  /// TODO: rename to onQueueData
  const onMsgData = useCallback((msg) => {
    msg.ack();
    if (msg.body) {
      const data = JSON.parse(msg.body);
      setMsgData(data);
    }
  }, []);

  //
  // ---[  onTopicData  ]---
  //
  const onTopicData = useCallback((msg) => {
    msg.ack();
    if (msg.body) {
      const data = JSON.parse(msg.body);
      console.log('[useWebSocketComm onTopicData] [data: %s]', JSON.stringify(data));
      setTopicData(data);
    }
  }, []);


  // ---[  EFFECT  ]---  1. Operator Ready:  Subscribe qPath + topicPath.
  //
  useEffect(()=>{
    if (isOperatorReady()) { // TODO: REMOVE AND CONSIDER ONLY operator?.username  OR  operator?.selectedTeamId
      if (Boolean(operator.selectedTeamId) && Boolean(teamTopicName)) {
        const channel = `/topic/team/${operator.selectedTeamId}/${teamTopicName}`;
        subscribeIfAbsent(channel, onTopicData);
        setTopicPath(channel);
      }

      if (qPath) {
        subscribeIfAbsent(qPath, onMsgData);
      }
    }
  },[operatorState, operator?.selectedTeamId, teamTopicName, isOperatorReady, subscribeIfAbsent, qPath, onMsgData, onTopicData]);
  
  //
  // ---[  onActorMount  ]---       1a.  ActorMounted(true) + Subsribe
  //
  const onActorMount = useCallback(() => {
    console.debug('[useWebSocketComm onActorMount]');
    if (qPath) {
      subscribeIfAbsent(qPath, onMsgData);
    }
    
    if (topicPath) {
      subscribeIfAbsent(topicPath, onTopicData);
    }

    setActorMounted(true);
  }, [qPath, subscribeIfAbsent, topicPath, onMsgData, onTopicData]);

  //
  // ---[  onActorCleanup  ]---     1b.  ActorMounted(false) + Unsubscribe
  //
  const onActorCleanup = useCallback(() => {
    console.log('[useWebSocketComm onActorCleanup]');
    Object.keys(getMySubsList()).forEach(channelName => {
      const subId = getMySubsList()[channelName];
      wsUnsubscribe(subId);
      delete getMySubsList()[channelName];
      console.log('[useWebSocketComm onActorCleanup] Removed from MySubsList [channel: %s] ');      
    });
    setActorMounted(false);
  },[getMySubsList, wsUnsubscribe]);

  // ---[   Effect   ]---            2.  WebSocketFlag.Ready  --->  AutoSend Once
  useEffect(()=>{
    if(!isAutoMessageSent() && isWebSocketFlag(WebSocketFlag.Ready) && isActorMounted && Boolean(autoSend) && Boolean(requestor)) {
      sendMsg(request);
      setAutoMessageSent(true);
    }
  },[webSocketState, isWebSocketFlag, isActorMounted, autoSend, requestor, isAutoMessageSent, request, sendMsg, setAutoMessageSent]);


  // --- Return ---
  return {
    onMyMount:onActorMount,
    onMyCleanup:onActorCleanup,
    myData:msgData,
    teamData:topicData,
    sendMsg
  }
}
